/**
 * `useCallRoom` — subscribes to the call room when a call detail view opens.
 *
 * The call room receives high-frequency events (transcript segments) for a
 * single live call. Mount inside a call detail view or live-call side panel.
 * Unmounting automatically unsubscribes.
 */
import { useEffect } from 'react';
import { subscribeCallRoom } from '../rooms';
import { useRealtimeContext } from './RealtimeProvider';

export function useCallRoom(tenantId: string, hotelId: string, callId: string): void {
  const { socket, reconnectManager } = useRealtimeContext();

  useEffect(() => {
    reconnectManager.trackCallRoom(tenantId, hotelId, callId);

    const unsubscribe = subscribeCallRoom(socket, hotelId, callId);

    return () => {
      reconnectManager.untrackCallRoom(callId);
      unsubscribe();
    };
  }, [socket, reconnectManager, tenantId, hotelId, callId]);
}
